import React from 'react';
import tw from 'twin.macro';
import Card from '@teetsh/app/src/components/Card';

interface Props {
  name?: string | React.ReactNode;
  stat?: string | number | React.ReactNode;
  disabled?: boolean;
  small?: boolean;
  wrap?: boolean;
  grow?: boolean;
  'data-testId'?: string;
  className?: string;
}

export function StatsCard(props: Props) {
  const { name, stat, disabled, small, wrap, grow, className } = props;
  return (
    <Card
      className={className}
      data-testid={props['data-testId']}
      css={[
        disabled && tw`bg-neutral-moderate opacity-40`,
        small && tw`p-4!`,
        grow && tw`flex flex-col justify-between`,
      ]}
    >
      <dt
        css={[
          tw`text-sm font-medium text-neutral-moderate`,
          !wrap && tw`truncate`,
        ]}
      >
        {name}
      </dt>
      {stat === undefined && !disabled ? (
        <dd className="tsh-skeleton" tw="mt-1 text-3xl h-8" />
      ) : (
        <dd css={[tw`mt-1 text-3xl font-semibold`, small && tw`text-xl`]}>
          {stat}
        </dd>
      )}
    </Card>
  );
}
